const pdfBase64ToBlobUrl = (pdfBase64) => {
  const byteChars = atob(pdfBase64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i += 1) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
};

/**
 * Imprime el PDF del ticket desde la misma pestaña.
 * El cuadro de Chrome se abre recién cuando el PDF ya cargó, y el iframe se elimina al cerrar el diálogo.
 */
export const openPdfBase64AndPrint = (pdfBase64) => {
  let blobUrl = '';
  try {
    blobUrl = pdfBase64ToBlobUrl(pdfBase64);
  } catch (_) {
    return false;
  }

  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', 'Ticket');
  iframe.style.cssText = 'position:fixed;left:0;top:0;width:420px;height:800px;border:0;opacity:0;pointer-events:none;';
  iframe.src = blobUrl;

  let finished = false;
  let printed = false;
  const cleanup = () => {
    if (finished) return;
    finished = true;
    if (blobUrl) URL.revokeObjectURL(blobUrl);
    iframe.remove();
  };

  const triggerPrint = () => {
    if (printed || finished) return;
    const printWindow = iframe.contentWindow;
    if (!printWindow) return;
    printed = true;
    try {
      printWindow.addEventListener('afterprint', () => setTimeout(cleanup, 200), { once: true });
    } catch (_) {}
    try {
      window.addEventListener('afterprint', () => setTimeout(cleanup, 200), { once: true });
    } catch (_) {}
    try {
      printWindow.focus();
      printWindow.print();
    } catch (_) {
      cleanup();
    }
  };

  iframe.onload = () => {
    setTimeout(triggerPrint, 600);
  };

  document.body.appendChild(iframe);
  setTimeout(triggerPrint, 1800);
  setTimeout(cleanup, 120000);
  return true;
};
